<template>
  <div class="offlinefile">
    <el-form ref="ruleFormRef" :model="tableParams" class="head" :inline="true">
      <el-form-item label="状态">
        <h-selectcode
          bx="bx"
          type="file_upload_status"
          v-model="tableParams.uploadStatus"
        ></h-selectcode>
      </el-form-item>
      <el-form-item label="视频来源">
        <el-select
          clearable
          v-model="tableParams.fileSource"
          placeholder="不限"
        >
          <el-option
            v-for="item in fileSourceList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :disabled="item.disabled"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="录像时段">
        <div class="block">
          <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            :shortcuts="shortcuts"
            range-separator="~"
            start-placeholder="开始"
            end-placeholder="结束"
          />
        </div>
      </el-form-item>
      <el-form-item class="search">
        <el-input
          v-model="tableParams.search"
          placeholder="文件名/录像地点/创建人"
        >
          <template #suffix>
            <div @click="refreshTable">
              <el-icon>
                <Search></Search>
              </el-icon>
            </div>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="btn">
      <h-button type="primary" @click="uploading">上传</h-button>
      <h-button type="danger" :disabled="TableSelect.length === 0" @click="del"
        >删除</h-button
      >
      <el-dropdown style="margin-left: 12px">
        <el-button :disabled="TableSelect.length === 0" type="primary"
          >批量分组</el-button
        >
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              @click="typeClick(item)"
              v-for="item in typelist"
              :key="item"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="fileslist"
      :params="tableParams"
      @select="hzTableSelect"
      style="height: 95%"
    >
      <template #fileName="{ row }">
        <div class="table-role" @click="detial(row)">
          <span>{{ row.fileName }}</span>
        </div>
      </template>
      <template #state="{ row }">
        <span :style="{ color: row.uploadStatus == '2' ? 'red' : '' }">
          <el-progress :stroke-width="10" :percentage="row.uploadProgress" />
          {{
            row.uploadStatus == "0"
              ? "上传成功"
              : row.uploadStatus == "1"
              ? "上传中"
              : row.uploadStatus == "2"
              ? "上传失败"
              : row.uploadStatus == "3"
              ? "校验中"
              : "校验失败"
          }}</span
        >
      </template>
      <template #fileSource="{ row }">
        <!-- 0-其他;1-设备自建监控点,2-行车记录仪;3-手机 -->
        <span>{{
          row.fileSource === 0
            ? "其他"
            : row.fileSource === 1
            ? "设备自建监控点"
            : row.fileSource === 2
            ? "行车记录仪"
            : "手机"
        }}</span>
      </template>
      <template #location="{ row }">
        <span>{{ row.location || "--" }}</span>
      </template>
      <template #startTime="{ row }">
        <span>{{ row.startTime === "0" ? "--" : "" }}</span>
      </template>
      <template #operate="{ row }">
        <h-button :type="'primary'" size="small" v-if="row.uploadStatus === '2'"
          >上传</h-button
        >
        <h-button :type="'primary'" size="small" @click="editor(row)"
          >编辑</h-button
        >
        <h-button :type="'primary'" size="small" @click="del(row)"
          >删除</h-button
        >
      </template>
    </h-table>
    <uploading
      v-if="flag"
      v-model:visible="flag"
      :status="uploadDialogStatus"
      :info="tableRow"
      @updataTable="refreshTable"
    ></uploading>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, toRefs } from "vue";
import { Search } from "@element-plus/icons-vue";
import uploading from "@/views/smartApplication/videoAnalysis/components/uploading.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  fileslist,
  filesbatchdelete,
  movefilesnewgroup,
} from "@/api/videoAnalysis/videoAnalysisApi.js";
import { fileSourceList } from "@/utils/videoAnalysisjs/videoAnalysisjs.js";
export default defineComponent({
  name: "offlinefile",
  components: { uploading, Search },
  props: {
    typelist: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const state = reactive({
      flag: false,
      tableData: [],
      getList: [],
      dateTime: [],

      columns: [
        { type: "selection" },
        {
          type: "index",
        },
        {
          label: "文件名称",
          slot: "fileName",
        },
        {
          label: "状态",
          slot: "state",
        },
        {
          label: "视频来源",
          slot: "fileSource",
        },
        {
          label: "录像地点",
          slot: "location",
        },
        {
          label: "录像发生时间",
          slot: "startTime",
        },
        {
          label: "创建人",
          prop: "creator",
        },
        {
          slot: "operate",
          label: "操作",
          width: "200px",
        },
      ],
      tableParams: {
        uploadStatus: "",
        fileSource: "",
        search: "",
        startTime: "",
        endTime: "",
      },
      TableSelect: [],
      tableRow: {},
      uploadDialogStatus: 1, //1  新建  2 编辑  3详情
    });
    const tableRef = ref(null);

    const del = async (row) => {
      ElMessageBox.confirm("确定要删除选中数据吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let params;
          if (row) {
            params = {
              fileId: [row.id],
            };
          } else {
            params = {
              fileId: state.TableSelect.map((item) => {
                return item.id;
              }),
            };
          }
          const res = await filesbatchdelete(params);
          if (res.code === 0) {
            ElMessage({
              type: "success",
              message: "删除成功",
            });
            refreshTable();
          }
        },
        () => {}
      );
    };
    //详情
    const detial = async (row) => {
      state.flag = true;
      state.tableRow = row;
      state.uploadDialogStatus = 3;
    };
    //编辑
    const editor = async (row) => {
      state.flag = true;
      state.tableRow = row;
      state.uploadDialogStatus = 2;
    };
    //上传
    const uploading = () => {
      state.flag = true;
      state.uploadDialogStatus = 1;
    };
    const hzTableSelect = (val) => {
      state.TableSelect = val;
    };

    // 点击查询按钮
    const refreshTable = () => {
      if (state.dateTime) {
        state.tableParams.startTime = state.dateTime[0];
        state.tableParams.endTime = state.dateTime[1];
      } else {
        state.tableParams.startTime = "";
        state.tableParams.endTime = "";
      }
      tableRef.value && tableRef.value.refresh();
    };
    const typeClick = async (item) => {
      const params = {
        fileIds: state.TableSelect.map((items) => {
          return items.id;
        }),
        groupId: item.id,
      };
      const res = await movefilesnewgroup(params);
      if (res.code === 0) {
        ElMessage({
          type: "success",
          message: "移动成功",
        });
        refreshTable();
      }
    };
    return {
      fileslist,
      typeClick,
      ...toRefs(state),
      refreshTable,
      Search,
      tableRef,
      uploading,
      fileSourceList,
      del,
      editor,
      detial,
      hzTableSelect,
    };
  },
});
</script>

<style lang="scss" scoped>
.offlinefile {
  height: 100%;
  .head {
    // height: 60px;
  }
}
.btn {
  display: flex;
  height: 40px;
}
.h-table {
  height: calc(100% - 100px);
}
.table-role {
  color: #294a7c;
  cursor: pointer;
}
</style>
